<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="1100px"
      class="adaptationModal"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div class="editTitle">采购信息</div>
      <el-row>
        <el-col v-if="model.pkid" :span="12">
          <el-form-item label="编号">
            <el-input v-model="model.no" disabled/> 
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商" prop="supplierName">
            <el-input v-model="model.supplierName" placeholder="请选择供应商" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.supplierSelect.open()"/>
            </el-input>
            <supplier-select ref="supplierSelect" @select="supplierSelect"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="model.note" type="textarea" autosize/> 
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">采购明细</div>
      <el-button type="primary" style="margin-bottom: 8px" @click="$refs.materialSelect.open()"> 添加 </el-button>
      <Table 
          class="purchaseTable" 
          border 
          stripe
          :height="model.details.length >= 10 ? '415' : ''"
          :columns="columns" 
          :data="model.details">
        <template slot="planDeliveryDate" slot-scope="{ row, index }">
          <el-input v-model="row.planDeliveryDate" @input="inputHandle(row, index)"/>
        </template>
        <template slot="taxPrice" slot-scope="{ row, index }">
          <el-input v-model="row.taxPrice" @input="inputHandle(row, index)"/>
        </template>
        <template slot="note" slot-scope="{ row, index }">
          <el-input v-model="row.note" class="noteInput" @input="inputHandle(row, index)"/>
        </template>
        <template slot="action" slot-scope="{ index }">
          <el-button type="danger" @click="model.details.splice(index, 1)">删除</el-button>
        </template>
      </Table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <material-select ref="materialSelect" @select="materialSelect"/>
  </el-dialog>
</template>

<script>
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  export default {
    components: {
      SupplierSelect,
      MaterialSelect,
    },

    data() {
      return {
        disabled: false,
        contentLoading: false,
        dialogVisible: false,
        submitLoading: false,
        model: {
          pkid: 0,
          no: "",
          supplierId: "",
          supplierNo: "",
          supplierName: "",
          note:"",
          details: [],
        },
        ruleValidate: {
          supplierName: { required: true, message: "请选择供应商", trigger: "change" },
        },
        columns: [
          {
            title: "物料编号",
            key: "materialNo",
            width: 160,
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 365,
            tooltip: true,
          },
          {
            title: "单位",
            key: "unitName",
            width: 100,
            align: "center",
          },
          {
            title: "提前天数",
            key: "planDeliveryDate",
            width: 100,
            align: "center",
            slot: "planDeliveryDate",
          },
          {
            title: "含税价",
            key: "taxPrice",
            width: 100,
            align: "center",
            slot: "taxPrice",
          },
          {
            title: "备注",
            key: "note",
            width: 160,
            slot: "note",
          },
          {
            title: "操作",
            align: "center",
            width: 80,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getData(row.pkid);
        }
      },

      getData(masterId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `purchaseRecords/${masterId}`)
          .then((res) => {
            if (res.success) {
              this.model = Object.assign(this.model, res.data);
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      supplierSelect(row) {
        this.model.supplierNo = row.no;
        this.model.supplierName = row.name;
        this.model.supplierId = row.pkid;
      },

      materialSelect(row) {
        console.log(row);
        const arr = this.model.details.filter((item) => item.materialNo === row.materialNO);
        if (arr.length) {
          this.$confirm("该物料已存在，请勿重复添加！", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          let item = {
            materialName: row.materialName,
            materialNo: row.materialNO,
            materialId: row.materialID,
            planDeliveryDate: 20,
            taxPrice: 0,
            unitName:row.unitName,
          };
          this.model.details.push(item);
        }
      },

      inputHandle(row, index) {
        this.$set(this.model.details, index, row);
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "purchaseRecords", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.model.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.purchaseTable .el-input__inner {
  text-align: center;
}
.purchaseTable .noteInput .el-input__inner {
  text-align: left;
}
</style>
